import { Link } from "react-router-dom";
import LegalPageLayout, { LegalSection } from "@/components/LegalPageLayout";
import { getPhase1MainServices } from "@/data/seo/mainServices";
import { getPhase1Cities } from "@/data/seo/cities";
import { getPhase1Routes } from "@/data/seo/routes";
import { resolvePlace } from "@/data/seo/cities";

function LinkList({ links, prefix = "" }) {
  return (
    <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 mt-2">
      {links.map((link) => (
        <li key={link.href}>
          <Link to={link.href} className="text-navy hover:text-orange transition-colors">
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default function PlanDuSitePage() {
  const services = getPhase1MainServices().map((s) => ({ label: s.label, href: `/${s.slug}` }));
  const cities = getPhase1Cities().map((c) => ({ label: `Transport ${c.name}`, href: `/transport-${c.slug}` }));
  const routes = getPhase1Routes().map((r) => {
    const from = resolvePlace(r.fromSlug);
    const to = resolvePlace(r.toSlug);
    return { label: `Transport ${from?.name} — ${to?.name}`, href: `/transport-${r.slug}` };
  });

  return (
    <LegalPageLayout
      title="Plan du site"
      path="/plan-du-site"
      description="Plan du site Express Delivery : services, zones desservies, trajets et pages d'information."
      testId="plan-du-site-page"
    >
      <LegalSection title="Pages principales">
        <LinkList
          links={[
            { label: "Accueil", href: "/" },
            { label: "Transport Paris", href: "/transport-paris" },
            { label: "Transport Normandie", href: "/transport-normandie" },
          ]}
        />
      </LegalSection>
      <LegalSection title="Services">
        <LinkList links={services} />
      </LegalSection>
      <LegalSection title="Zones desservies">
        <LinkList links={cities} />
      </LegalSection>
      <LegalSection title="Trajets">
        <LinkList links={routes} />
      </LegalSection>
      <LegalSection title="Informations">
        <LinkList
          links={[
            { label: "Mentions légales", href: "/mentions-legales" },
            { label: "Politique de confidentialité", href: "/politique-de-confidentialite" },
            { label: "Politique cookies", href: "/politique-cookies" },
            { label: "Conditions générales", href: "/conditions-generales" },
            { label: "Réclamations", href: "/reclamations" },
          ]}
        />
      </LegalSection>
    </LegalPageLayout>
  );
}
